import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initScrollTracking, initAnalytics, cleanupAnalytics } from './analytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    return cleanupAnalytics;
  }, []);

  useEffect(() => {
    // Skip admin routes
    if (location.pathname.startsWith('/admin')) return;
    trackPageView(location.pathname);
    initScrollTracking();
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
